'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.destroyAllSubscriptions = exports.subscriptionStoreForAppName = undefined;

var _lodash = require('lodash');

var store = {};
window.fkss = store;

var subscriptionStoreForAppName = exports.subscriptionStoreForAppName = function subscriptionStoreForAppName(appName) {
  if (!store[appName]) {
    // console.log("Creating new subscription store for ", appName)
    store[appName] = {};
  } else {// console.log("Reusing existing subscription store for ", appName)
  }

  return store[appName];
};

var destroyAllSubscriptions = exports.destroyAllSubscriptions = function destroyAllSubscriptions() {
  (0, _lodash.forEach)(store, function (subStore, name) {
    (0, _lodash.forEach)(subStore, function (sub) {
      return sub.destroy();
    });
    delete store[name];
  });
};